export default "__VITE_ASSET__6fbed8f8__"